export const TOKEN_CONTACT_ID = "{{contactId}}";
export const TOKEN_HOSTNAME_ENV = ".{{env}}.";
export const TOKEN_PRI = "{{personRefId}}";
export const TOKEN_ROOT = "{{root}}";
export const TOKEN_SCOPE = "{{scope}}";